import React, { ReactNode } from 'react';
import { ApolloError } from '@apollo/client';
import { Box } from '@material-ui/core';

import { css } from './styles';

interface IMainProps {
  children: ReactNode;
  errorOrderDetails: ApolloError | undefined;
  errorOrderHistory?: ApolloError | undefined;
}

export const Main = ({ children, errorOrderDetails, errorOrderHistory }: IMainProps) => {
  const styles = css();

  if (errorOrderDetails || errorOrderHistory) {
    throw new Error('Ocorreu um problema ao carregar os detalhes do pedido.');
  }

  return <Box className={styles.main}>{children}</Box>;
};
